(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2661],{

/***/ 97878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tag": function() { return /* binding */ Tag; },
  "Tags": function() { return /* binding */ Tags; },
  "default": function() { return /* binding */ video_player; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/video.js/dist/video.es.js
var video_es = __webpack_require__(85215);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
;// CONCATENATED MODULE: ./lib/videoSourcesSwitcher.js
/*! videojs-resolution-switcher - 2015-7-26
 * Copyright (c) 2016 Kasper Moskwiak
 * Modified by Pierre Kraft and Derk-Jan Hartman
 * Licensed under the Apache-2.0 license. */

function videoSourcesSwitcher() {
  /* jshint eqnull: true*/
  /* global require */
  'use strict';
  var videojs = null;
  if (typeof window.videojs === 'undefined' && "function" === 'function') {
    videojs = (__webpack_require__(85215)["default"]);
  } else {
    videojs = window.videojs;
  }

  (function (window, videojs) {
    var videoJsResolutionSwitcher,
    defaults = {
      ui: true };


    /*
     * Resolution menu item
     */
    var MenuItem = videojs.getComponent('MenuItem');
    var ResolutionMenuItem = videojs.extend(MenuItem, {
      constructor: function constructor(player, options) {
        options.selectable = true;
        // Sets this.player_, this.options_ and initializes the component
        MenuItem.call(this, player, options);
        this.src = options.src;

        player.on('resolutionchange', videojs.bind(this, this.update));
      } });

    ResolutionMenuItem.prototype.handleClick = function (event) {
      MenuItem.prototype.handleClick.call(this, event);
      this.player_.currentResolution(this.options_.label);
    };
    ResolutionMenuItem.prototype.update = function () {
      var selection = this.player_.currentResolution();
      this.selected(this.options_.label === selection.label);
    };
    MenuItem.registerComponent('ResolutionMenuItem', ResolutionMenuItem);

    /*
     * Resolution menu button
     */
    var MenuButton = videojs.getComponent('MenuButton');
    var ResolutionMenuButton = videojs.extend(MenuButton, {
      constructor: function constructor(player, options) {
        this.label = document.createElement('span');
        options.label = 'Quality';
        // Sets this.player_, this.options_ and initializes the component
        MenuButton.call(this, player, options);
        this.el().setAttribute('aria-label', 'Quality');
        this.controlText('Quality');

        if (options.dynamicLabel) {
          videojs.dom.addClass(this.label, 'vjs-resolution-button-label');
          this.el().appendChild(this.label);
        } else {
          var staticLabel = document.createElement('span');
          videojs.dom.addClass(staticLabel, 'vjs-menu-icon');
          this.el().appendChild(staticLabel);
        }
        player.on('updateSources', videojs.bind(this, this.update));
      } });

    ResolutionMenuButton.prototype.createItems = function () {
      var menuItems = [];
      var labels = this.sources && this.sources.label || {};

      // FIXME order is not guaranteed here.
      for (var key in labels) {
        if (labels.hasOwnProperty(key)) {
          menuItems.push(
          new ResolutionMenuItem(this.player_, {
            label: key,
            src: labels[key],
            selected:
            key === (
            this.currentSelection ? this.currentSelection.label : false) }));


        }
      }
      return menuItems;
    };
    ResolutionMenuButton.prototype.update = function () {
      this.sources = this.player_.getGroupedSrc();
      this.currentSelection = this.player_.currentResolution();
      this.label.innerHTML = this.currentSelection ?
      this.currentSelection.label :
      '';
      return MenuButton.prototype.update.call(this);
    };
    ResolutionMenuButton.prototype.buildCSSClass = function () {
      return (
        MenuButton.prototype.buildCSSClass.call(this) + ' vjs-resolution-button');

    };
    MenuButton.registerComponent('ResolutionMenuButton', ResolutionMenuButton);

    /**
     * Initialize the plugin.
     * @param {object} [options] configuration for the plugin
     */
    videoJsResolutionSwitcher = function videoJsResolutionSwitcher(options) {
      var settings = videojs.mergeOptions(defaults, options),
      player = this,
      groupedSrc = {},
      currentSources = {},
      currentResolutionState = {};

      /**
       * Updates player sources or returns current source URL
       * @param   {Array}  [src] array of sources [{src: '', type: '', label: '', res: ''}]
       * @returns {Object|String|Array} videojs player object if used as setter or current source URL, object, or array of sources
       */
      player.updateSrc = function (src) {
        //Return current src if src is not given
        if (!src) {
          return player.src();
        }

        // Only add those sources which we can (maybe) play
        src = src.filter(function (source) {
          try {
            return player.canPlayType(source.type) !== '';
          } catch (e) {
            // If a Tech doesn't yet have canPlayType just add it
            return true;
          }
        });
        //Sort sources
        this.currentSources = src.sort(compareResolutions);
        this.groupedSrc = bucketSources(this.currentSources);
        // Pick one by default
        var chosen = chooseSrc(this.groupedSrc, this.currentSources);
        this.currentResolutionState = {
          label: chosen.label,
          sources: chosen.sources };


        player.trigger('updateSources');
        player.setSourcesSanitized(chosen.sources, chosen.label);
        player.trigger('resolutionchange');
        return player;
      };

      /**
       * Returns current resolution or sets one when label is specified
       * @param {String}   [label]         label name
       * @param {Function} [customSourcePicker] custom function to choose source. Takes 2 arguments: sources, label. Must return player object.
       * @returns {Object}   current resolution object {label: '', sources: []} if used as getter or player object if used as setter
       */
      player.currentResolution = function (label, customSourcePicker) {
        if (label == null) {
          return this.currentResolutionState;
        }

        // Lookup sources for label
        if (
        !this.groupedSrc ||
        !this.groupedSrc.label ||
        !this.groupedSrc.label[label])
        {
          return;
        }
        var sources = this.groupedSrc.label[label];
        // Remember player state
        var currentTime = player.currentTime();
        var isPaused = player.paused();

        // Hide bigPlayButton
        if (!isPaused && this.player_.options_.bigPlayButton) {
          this.player_.bigPlayButton.hide();
        }

        // Change player source and wait for loadeddata event, then play video
        // loadedmetadata doesn't work right now for flash.
        // Probably because of https://github.com/videojs/video-js-swf/issues/124
        // If player preload is 'none' and then loadeddata not fired. So, we need timeupdate event for seek handle (timeupdate doesn't work properly with flash)
        var handleSeekEvent = 'loadeddata';
        if (
        this.player_.techName_ !== 'Youtube' &&
        this.player_.preload() === 'none' &&
        this.player_.techName_ !== 'Flash')
        {
          handleSeekEvent = 'timeupdate';
        }
        player.
        setSourcesSanitized(
        sources,
        label,
        customSourcePicker || settings.customSourcePicker).

        one(handleSeekEvent, function () {
          player.currentTime(currentTime);
          player.handleTechSeeked_();
          if (!isPaused) {
            // Start playing and hide loadingSpinner (flash issue ?)
            player.play();
            player.handleTechSeeked_();
          }
          player.trigger('resolutionchange');
        });
        return player;
      };

      /**
       * Returns grouped sources by label, resolution and type
       * @returns {Object} grouped sources: { label: { key: [] }, res: { key: [] }, type: { key: [] } }
       */
      player.getGroupedSrc = function () {
        return this.groupedSrc;
      };

      player.setSourcesSanitized = function (
      sources,
      label,
      customSourcePicker)
      {
        this.currentResolutionState = {
          label: label,
          sources: sources };

        if (typeof customSourcePicker === 'function') {
          return customSourcePicker(player, sources, label);
        }
        player.src(
        sources.map(function (src) {
          return { src: src.src, type: src.type, res: src.res };
        }));

        return player;
      };

      /**
       * Method used for sorting list of sources
       * @param   {Object} a - source object with res property
       * @param   {Object} b - source object with res property
       * @returns {Number} result of comparation
       */
      function compareResolutions(a, b) {
        if (!a.res || !b.res) {
          return 0;
        }
        return +b.res - +a.res;
      }

      /**
       * Group sources by label, resolution and type
       * @param   {Array}  src Array of sources
       * @returns {Object} grouped sources: { label: { key: [] }, res: { key: [] }, type: { key: [] } }
       */
      function bucketSources(src) {
        var resolutions = {
          label: {},
          res: {},
          type: {} };

        src.map(function (source) {
          initResolutionKey(resolutions, 'label', source);
          initResolutionKey(resolutions, 'res', source);
          initResolutionKey(resolutions, 'type', source);

          appendSourceToKey(resolutions, 'label', source);
          appendSourceToKey(resolutions, 'res', source);
          appendSourceToKey(resolutions, 'type', source);
        });
        return resolutions;
      }

      function initResolutionKey(resolutions, key, source) {
        if (resolutions[key][source[key]] == null) {
          resolutions[key][source[key]] = [];
        }
      }

      function appendSourceToKey(resolutions, key, source) {
        resolutions[key][source[key]].push(source);
      }

      /**
       * Choose src if option.default is specified
       * @param   {Object} groupedSrc {res: { key: [] }}
       * @param   {Array}  src Array of sources sorted by resolution used to find high and low res
       * @returns {Object} {res: string, sources: []}
       */
      function chooseSrc(groupedSrc, src) {
        var selectedRes = settings['default']; // use array access as default is a reserved keyword
        var selectedLabel = '';
        if (selectedRes === 'high') {
          selectedRes = src[0].res;
          selectedLabel = src[0].label;
        } else if (
        selectedRes === 'low' ||
        selectedRes == null ||
        !groupedSrc.res[selectedRes])
        {
          // Select low-res if default is low or not set
          selectedRes = src[src.length - 1].res;
          selectedLabel = src[src.length - 1].label;
        } else if (groupedSrc.res[selectedRes]) {
          selectedLabel = groupedSrc.res[selectedRes][0].label;
        }

        return {
          res: selectedRes,
          label: selectedLabel,
          sources: groupedSrc.res[selectedRes] };

      }

      function initResolutionForYt(player) {
        // Map youtube qualities names
        var _yts = {
          highres: { res: 1080, label: '1080', yt: 'highres' },
          hd1080: { res: 1080, label: '1080', yt: 'hd1080' },
          hd720: { res: 720, label: '720', yt: 'hd720' },
          large: { res: 480, label: '480', yt: 'large' },
          medium: { res: 360, label: '360', yt: 'medium' },
          small: { res: 240, label: '240', yt: 'small' },
          tiny: { res: 144, label: '144', yt: 'tiny' },
          auto: { res: 0, label: 'auto', yt: 'auto' } };

        // Overwrite default sourcePicker function
        var _customSourcePicker = function _customSourcePicker(_player, _sources, _label) {
          // Note that setPlayebackQuality is a suggestion. YT does not always obey it.
          player.tech_.ytPlayer.setPlaybackQuality(_sources[0]._yt);
          player.trigger('updateSources');
          return player;
        };
        settings.customSourcePicker = _customSourcePicker;

        // Init resolution
        player.tech_.ytPlayer.setPlaybackQuality('auto');

        // This is triggered when the resolution actually changes
        player.tech_.ytPlayer.addEventListener(
        'onPlaybackQualityChange',
        function (event) {
          for (var res in _yts) {
            if (res.yt === event.data) {
              player.currentResolution(res.label, _customSourcePicker);
              return;
            }
          }
        });


        // We must wait for play event
        player.one('play', function () {
          var qualities = player.tech_.ytPlayer.getAvailableQualityLevels();
          var _sources = [];

          qualities.map(function (q) {
            _sources.push({
              src: player.src().src,
              type: player.src().type,
              label: _yts[q].label,
              res: _yts[q].res,
              _yt: _yts[q].yt });

          });

          player.groupedSrc = bucketSources(_sources);
          var chosen = {
            label: 'auto',
            res: 0,
            sources: player.groupedSrc.label.auto };


          this.currentResolutionState = {
            label: chosen.label,
            sources: chosen.sources };


          player.trigger('updateSources');
          player.setSourcesSanitized(
          chosen.sources,
          chosen.label,
          _customSourcePicker);

        });
      }

      player.ready(function () {
        if (settings.ui) {
          var menuButton = new ResolutionMenuButton(player, settings);
          player.controlBar.resolutionSwitcher = player.controlBar.el_.insertBefore(
          menuButton.el_,
          player.controlBar.getChild('fullscreenToggle').el_);

          player.controlBar.resolutionSwitcher.dispose = function () {
            this.parentNode.removeChild(this);
          };
        }
        if (player.options_.sources.length > 1) {
          // tech: Html5 and Flash
          // Create resolution switcher for videos form <source> tag inside <video>
          player.updateSrc(player.options_.sources);
        }

        if (player.techName_ === 'Youtube') {
          // tech: YouTube
          initResolutionForYt(player);
        }
      });
    };

    // register the plugin
    videojs.registerPlugin(
    'videoJsResolutionSwitcher',
    videoJsResolutionSwitcher);

  })(window, videojs);
}
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var react_esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./organisms/modals/LoginModal.tsx
var LoginModal = __webpack_require__(77495);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
// EXTERNAL MODULE: ./lib/analytics/manager.ts + 4 modules
var manager = __webpack_require__(88224);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./organisms/video-player/VideoCoverLocked.js













var Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "VideoCoverLocked__Wrapper", componentId: "sc-1wfzlgv-0" })(["background-color:", ";padding-bottom:56%;position:relative;"],
function (props) {return props.theme.colors.secondary['gray-5'];});




var AbsoluteCenter = styled_components_browser_esm["default"].div.withConfig({ displayName: "VideoCoverLocked__AbsoluteCenter", componentId: "sc-1wfzlgv-1" })(["position:absolute;top:50%;transform:translate(0%,-50%);"]);





var Message = styled_components_browser_esm["default"].p.withConfig({ displayName: "VideoCoverLocked__Message", componentId: "sc-1wfzlgv-2" })(["@media (max-width:", "){font-size:12px;}font-size:24px;font-weight:300;color:#ffffff;text-align:center;margin:0;padding:0;"],
function (props) {return "".concat(props.theme.viewports.mobile, "px");});










var VideoCoverLocked = function VideoCoverLocked() {
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0],loading = _useContext[1].loading;
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  var onUpgrade = function onUpgrade() {
    //track
    (0,manager/* default */.Z)()._PIXEL_TRACK('Upgrade From Video Lock', true);
    router_default().push("/[lang]/me/settings/[pageId]", "/".concat(

    lang, "/me/settings/subscriptions"));

  };

  var onRegister = function onRegister() {
    // e.preventDefault();
    (0,manager/* default */.Z)()._PIXEL_TRACK('Register From Video Lock', true);
    // location.href = `/register`;
  };

  var onLogin = function onLogin() {
    (0,manager/* default */.Z)()._PIXEL_TRACK('Login From Video Lock', true);
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Wrapper, { children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(AbsoluteCenter, { children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { px: ['20px', '20px', '60px'], py: ['20px', '20px', '0px'], children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "center", mb: ['10px', '10px', '20px'], children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-infob", fontSize: "30px", color: "white" }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: ['10px', '10px', '30px'], children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Message, { children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "video.premium_msg",
                message: "You have watched a 60 second preview. Do you want to see the rest?" }) }) }),



          function () {
            if (loading) return null;
            if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
              return /*#__PURE__*/(
                (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "center", children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "5px", children: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                      appearance: "default-white",
                      onClick: function onClick() {return onUpgrade();}, children: /*#__PURE__*/

                      (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                        id: "video_cover_locked.Upgrade",
                        message: "Upgrade" }) }) }) }));





            } else {
              return /*#__PURE__*/(
                (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { justifyContent: "center", children: [/*#__PURE__*/
                  (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "5px", children: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(LoginModal/* default */.Z, { children:
                      function children(handleOpenModal) {return /*#__PURE__*/(
                          (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                            appearance: "default-white",
                            onClick: function onClick() {
                              onLogin();
                              handleOpenModal();
                            }, children: /*#__PURE__*/

                            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                              id: "video_cover_locked.login",
                              message: "Login" }) }));} }) }), /*#__PURE__*/





                  (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "5px", children: /*#__PURE__*/
                    (0,jsx_runtime.jsx)((link_default()), {
                      href: "/[lang]/register/account",
                      as: "/".concat(lang, "/register/account"),
                      legacyBehavior: true, children: /*#__PURE__*/
                      (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                        appearance: "default-pink",
                        href: "/".concat(lang, "/register/account"),
                        onClick: onRegister, children: /*#__PURE__*/

                        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                          id: "video_cover_locked.register",
                          message: "Try for Free" }) }) }) })] }));






            }
          }()] }) }) }));




};

/* harmony default export */ var video_player_VideoCoverLocked = (VideoCoverLocked);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(20745);
// EXTERNAL MODULE: ./lib/theme.ts
var theme = __webpack_require__(62594);
;// CONCATENATED MODULE: ./organisms/video-player/vjsAirplayButton.js
function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}





var IconWrapper = styled_components_browser_esm["default"].span.withConfig({ displayName: "vjsAirplayButton__IconWrapper", componentId: "sc-zmyj1j-0" })(["cursor:pointer;max-height:40px;svg{max-height:40px;width:100%;padding:7px;display:block;svg{max-height:40px;}}"]);













var vjsComponent = video_es["default"].getComponent('Button');var

VjsAirplayButton = /*#__PURE__*/function (_vjsComponent) {(0,inherits/* default */.Z)(VjsAirplayButton, _vjsComponent);var _super = _createSuper(VjsAirplayButton);
  function VjsAirplayButton(player, options) {var _this;(0,classCallCheck/* default */.Z)(this, VjsAirplayButton);
    _this = _super.call(this, player, options);(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "buttonText",


















    function () {
      return null;
    });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "iconClassName",

    function () {
      return 'ygb-icon-cast';
    });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "castStateClass",





    function () {});_this.root = (0,client.createRoot)(_this.el()); /* Bind the current class context to the mount method */_this.mount = _this.mount.bind((0,assertThisInitialized/* default */.Z)(_this));_this.configOptions = options; /* When player is ready, call method to mount React component */_this.addClass('vjs-control');_this.addClass('vjs-button');_this.addClass('vjs-button-airplay');player.ready(function () {_this.mount();}); /* Remove React root when component is destroyed */_this.on('dispose', function () {_this.root.unmount();});return _this;}(0,createClass/* default */.Z)(VjsAirplayButton, [{ key: "airplay", value: function airplay() {var _this$player_, _this$player_$childre, _this$player_$childre2, _this$player_$childre3;this === null || this === void 0 ? void 0 : (_this$player_ = this.player_) === null || _this$player_ === void 0 ? void 0 : (_this$player_$childre = _this$player_.children_) === null || _this$player_$childre === void 0 ? void 0 : (_this$player_$childre2 = _this$player_$childre[0]) === null || _this$player_$childre2 === void 0 ? void 0 : (_this$player_$childre3 = _this$player_$childre2.webkitShowPlaybackTargetPicker) === null || _this$player_$childre3 === void 0 ? void 0 : _this$player_$childre3.call(_this$player_$childre2);} }, { key: "mount", value:
    /**
     * We will render out the React EpisodeList component into the DOM element
     * generated automatically by the VideoJS createEl() method.
     *
     * We fetch that generated element using `this.el()`, a method provided by the
     * vjsComponent class that this class is extending.
     */
    function mount() {var _this2 = this;
      this.root.render( /*#__PURE__*/
      (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, { theme: theme/* default */.Z, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(IconWrapper, { onClick: function onClick() {return _this2.airplay();}, onTouchStart: this.cast, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)("svg", {
            fill: "#fff",
            version: "1.1",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg", children: /*#__PURE__*/

            (0,jsx_runtime.jsx)("path", { d: "M6,22H18L12,16M21,3H3A2,2 0 0,0 1,5V17A2,2 0 0,0 3,19H7V17H3V5H21V17H17V19H21A2,2 0 0,0 23,17V5A2,2 0 0,0 21,3Z" }) }) }) }));




    } }]);return VjsAirplayButton;}(vjsComponent);


/* harmony default export */ var vjsAirplayButton = (VjsAirplayButton);
;// CONCATENATED MODULE: ./organisms/video-player/CustomButton.js


var CustomButton = function CustomButton(props) {return /*#__PURE__*/(
    (0,jsx_runtime.jsx)("span", { className: props.classIconName, onClick: props.onClickHandler, children:
      props.body }));};



/* harmony default export */ var video_player_CustomButton = (CustomButton);
;// CONCATENATED MODULE: ./organisms/video-player/vjsCustomButton.js
function vjsCustomButton_createSuper(Derived) {var hasNativeReflectConstruct = vjsCustomButton_isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function vjsCustomButton_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}




var vjsCustomButton_vjsComponent = video_es["default"].getComponent('Button');var

VjsCustomButton = /*#__PURE__*/function (_vjsComponent) {(0,inherits/* default */.Z)(VjsCustomButton, _vjsComponent);var _super = vjsCustomButton_createSuper(VjsCustomButton);
  function VjsCustomButton(player, options) {var _this;(0,classCallCheck/* default */.Z)(this, VjsCustomButton);
    _this = _super.call(this, player, options);(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onClickHandler",






























    function (event) {
      switch (_this.configOptions.type) {
        case 'next':
          _this.configOptions.next();
          break;
        case 'prev':
          _this.configOptions.prev();
          break;
        // case 'cast':
        //   this.configOptions.cast();
        //   break;
        default:
          break;}

    });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "buttonText",

    function () {
      switch (_this.configOptions.type) {
        case 'next':
          return null;
        case 'prev':
          return null;
        // case 'cast':
        //   return 'cast';
        default:
          break;}

    });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "iconClassName",

    function () {
      switch (_this.configOptions.type) {
        case 'next':
          return 'ygb-icon-next2';
        case 'prev':
          return 'ygb-icon-previous2';
        // case 'cast':
        //   return 'cast-button';
        default:
          break;}

    });_this.root = (0,client.createRoot)(_this.el()); /* Bind the current class context to the mount method */_this.mount = _this.mount.bind((0,assertThisInitialized/* default */.Z)(_this));_this.handleClick = _this.onClickHandler.bind((0,assertThisInitialized/* default */.Z)(_this));_this.configOptions = options; /* When player is ready, call method to mount React component */_this.addClass('vjs-control');_this.addClass('vjs-button');switch (_this.configOptions.type) {case 'next':_this.addClass('vjs-button-next');break;case 'prev':_this.addClass('vjs-button-prev');break; // case 'cast':
      //   this.addClass('vjs-button-cast');
      //   break;
      default:break;}player.ready(function () {_this.mount();}); /* Remove React root when component is destroyed */_this.on('dispose', function () {_this.root.unmount();});return _this;}(0,createClass/* default */.Z)(VjsCustomButton, [{ key: "mount", value: /**
     * We will render out the React EpisodeList component into the DOM element
     * generated automatically by the VideoJS createEl() method.
     *
     * We fetch that generated element using `this.el()`, a method provided by the
     * vjsComponent class that this class is extending.
     */function mount() {this.root.render( /*#__PURE__*/
      (0,jsx_runtime.jsx)(video_player_CustomButton, {
        vjsComponent: this,
        body: this.buttonText(),
        classIconName: this.iconClassName(),
        onClickHandler: this.onClickHandler }));


    } }]);return VjsCustomButton;}(vjsCustomButton_vjsComponent);


/* harmony default export */ var vjsCustomButton = (VjsCustomButton);
// EXTERNAL MODULE: ./lib/hooks/useFlags.tsx
var useFlags = __webpack_require__(55932);
// EXTERNAL MODULE: ./node_modules/videojs-hls-quality-selector/dist/videojs-hls-quality-selector.cjs.js
var videojs_hls_quality_selector_cjs = __webpack_require__(20944);
var videojs_hls_quality_selector_cjs_default = /*#__PURE__*/__webpack_require__.n(videojs_hls_quality_selector_cjs);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(4338);
;// CONCATENATED MODULE: ./organisms/modals/useCastModal.tsx











var Modal = (0,styled_components_browser_esm["default"])(base/* Modal */.u_).withConfig({ displayName: "useCastModal__Modal", componentId: "sc-12gtq4r-0" })([".MuiDialog-paperFullScreen,.MuiDialog-paperFullScreen .ModalWrapper{height:auto;}"]);






var CloseButton = styled_components_browser_esm["default"].button.withConfig({ displayName: "useCastModal__CloseButton", componentId: "sc-12gtq4r-1" })(["position:absolute;top:15px;right:15px;color:#fff;border:none;background:none;z-index:1;cursor:pointer;"]);










var Body = (0,styled_components_browser_esm["default"])(base/* Body */.uT).withConfig({ displayName: "useCastModal__Body", componentId: "sc-12gtq4r-2" })(["padding:0;"]);



var Header = (0,styled_components_browser_esm["default"])(Grid/* Box */.xu).withConfig({ displayName: "useCastModal__Header", componentId: "sc-12gtq4r-3" })(["position:relative;height:200px;display:flex;justify-content:center;align-items:center;:before{content:'';position:absolute;top:0;left:0;height:100%;width:100%;background-color:rgba(157,201,199,0.8);z-index:1;}:after{content:'\\e948';display:block;font-family:'ygb-font';font-size:26px;color:#fff;text-align:center;z-index:2;}.CastModal--Img > div{width:100%;}"]);
































var Content = (0,styled_components_browser_esm["default"])(Grid/* Box */.xu).withConfig({ displayName: "useCastModal__Content", componentId: "sc-12gtq4r-4" })(["max-width:400px;text-align:center;margin:0 auto;"]);





var Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "useCastModal__Title", componentId: "sc-12gtq4r-5" })(["font-size:22px;font-weight:700;margin-top:0;"]);





var Text = styled_components_browser_esm["default"].p.withConfig({ displayName: "useCastModal__Text", componentId: "sc-12gtq4r-6" })(["font-size:18px;"]);







var CastModal = function CastModal(
props)



{
  var open = props.open;
  var _useState = (0,react.useState)(open),isOpen = _useState[0],setOpen = _useState[1];
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  var content = /*#__PURE__*/
  (0,jsx_runtime.jsx)(Modal, {
    open: isOpen,

    handleClose: function handleClose() {return setOpen(false);}, children: /*#__PURE__*/

    (0,jsx_runtime.jsxs)(Body, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(Header, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)((image_default()), {
          className: "CastModal--Img",
          alt: "",
          src: "/static/cheerful-sportswomen-giving-high-five-to-each-other.jpg",
          layout: "fill",
          objectFit: "cover" }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(CloseButton, { onClick: function onClick() {return setOpen(false);}, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-close", fontSize: "18px" }) })] }), /*#__PURE__*/


      (0,jsx_runtime.jsxs)(Content, { py: 40, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Title, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "cast_modal.title" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Text, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "cast_modal.subtitle" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Link/* default */.ZP, { href: "/".concat(lang, "/subscription/select"), children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "stone", href: "/".concat(lang, "/subscription/select"), children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "cast_modal.view_offers" }) }) })] })] }) });







  return [
  content,
  {
    isOpen: isOpen,
    openModal: function openModal() {return setOpen(true);},
    closeModal: function closeModal() {return setOpen(false);} }];


};

/* harmony default export */ var useCastModal = (CastModal);
// EXTERNAL MODULE: ./lib/hooks/useLoginModal.tsx
var useLoginModal = __webpack_require__(73074);
;// CONCATENATED MODULE: ./lib/react-cast-sender/utils/utils.ts
function loadScriptAsync(url) {
  return new Promise(function (resolve, reject) {
    var r = false,
    t = document.getElementsByTagName('script')[0],
    s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = url;
    s.async = true;
    //@ts-ignore
    s.onload = s.onreadystatechange = function () {
      //@ts-ignore
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        r = true;
        resolve(this);
      }
    };
    s.onerror = s.onabort = reject;
    if (t && t.parentNode) {
      t.parentNode.insertBefore(s, t);
    }
  });
}

var getDisplayTime = function getDisplayTime(time) {
  var showHour = time >= 3600;
  var h = Math.floor(time / 3600);
  var m = Math.floor(time / 60 % 60);
  var s = Math.floor(time % 60);
  if (s < 10) s = "0".concat(s);
  var text = "".concat(m, ":").concat(s);
  if (showHour || h > 0) {
    if (m < 10) {
      text = "0".concat(text);
    }
    text = "".concat(h, ":").concat(text);
  }
  return text;
};

var getDefaultTrackStyling = function getDefaultTrackStyling() {
  var style = new window.chrome.cast.media.TextTrackStyle();
  style.backgroundColor = '#00000000';
  style.edgeType = window.chrome.cast.media.TextTrackEdgeType.DROP_SHADOW;
  style.fontGenericFamily =
  window.chrome.cast.media.TextTrackFontGenericFamily.SANS_SERIF;
  style.edgeColor = '#000000';
  style.fontStyle = window.chrome.cast.media.TextTrackFontStyle.BOLD;
  return style;
};
;// CONCATENATED MODULE: ./lib/react-cast-sender/utils/CastLoader.ts


var SENDER_SDK_URL =
'//www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';

var _promise;var
CastLoader = /*#__PURE__*/function () {function CastLoader() {(0,classCallCheck/* default */.Z)(this, CastLoader);}(0,createClass/* default */.Z)(CastLoader, null, [{ key: "load", value:
    function load() {
      return new Promise(function (resolve) {
        CastLoader.loadCastSDK()["catch"](function (e) {
          console.warn('Cast sender lib loading failed', e.message);
        });
        window['__onGCastApiAvailable'] = function (isAvailable) {
          CastLoader.onGCastApiAvailable(isAvailable, resolve);
        };
      });
    } }, { key: "loadCastSDK", value:

    function loadCastSDK() {
      if (window['cast'] && window['cast']['framework'] || _promise) {
        return Promise.resolve();
      }
      _promise = loadScriptAsync(SENDER_SDK_URL);
      return _promise;
    } }, { key: "onGCastApiAvailable", value:

    function onGCastApiAvailable(
    isAvailable,
    resolve)
    {
      if (isAvailable) {
        resolve();
      } else {
        console.warn("Google cast API isn't available yet");
      }
    } }]);return CastLoader;}();



;// CONCATENATED MODULE: ./package.json
var package_namespaceObject = JSON.parse('{"HO":{"rA":"^7.21.1"}}');
// EXTERNAL MODULE: ./node_modules/videojs-contrib-quality-levels/dist/videojs-contrib-quality-levels.cjs.js
var videojs_contrib_quality_levels_cjs = __webpack_require__(65682);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js + 1 modules
var get = __webpack_require__(74450);
// EXTERNAL MODULE: ./node_modules/global/window.js
var global_window = __webpack_require__(58908);
var window_default = /*#__PURE__*/__webpack_require__.n(global_window);
;// CONCATENATED MODULE: ./organisms/video-player/overlay-plugin.js
function overlay_plugin_createSuper(Derived) {var hasNativeReflectConstruct = overlay_plugin_isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function overlay_plugin_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}


var defaults = {
  align: 'top-left',
  "class": '',
  content: 'This overlay will show up while the video is playing',
  debug: false,
  showBackground: true,
  attachToControlBar: false,
  overlays: [
  {
    start: 'playing',
    end: 'paused' }] };




var Component = video_es["default"].getComponent('Component');

var dom = video_es["default"].dom || video_es["default"];
var registerPlugin = video_es["default"].registerPlugin || video_es["default"].plugin;

/**
 * Whether the value is a `Number`.
 *
 * Both `Infinity` and `-Infinity` are accepted, but `NaN` is not.
 *
 * @param  {Number} n
 * @return {Boolean}
 */

/* eslint-disable no-self-compare */
var isNumber = function isNumber(n) {return typeof n === 'number' && n === n;};
/* eslint-enable no-self-compare */

/**
 * Whether a value is a string with no whitespace.
 *
 * @param  {String} s
 * @return {Boolean}
 */
var hasNoWhitespace = function hasNoWhitespace(s) {return typeof s === 'string' && /^\S+$/.test(s);};

/**
 * Overlay component.
 *
 * @class   Overlay
 * @extends {videojs.Component}
 */var
Overlay = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(Overlay, _Component);var _super = overlay_plugin_createSuper(Overlay);
  function Overlay(player, options) {var _this;(0,classCallCheck/* default */.Z)(this, Overlay);
    _this = _super.call(this, player, options);

    ['start', 'end'].forEach(function (key) {
      var value = _this.options_[key];

      if (isNumber(value)) {
        _this[key + 'Event_'] = 'timeupdate';
      } else if (hasNoWhitespace(value)) {
        _this[key + 'Event_'] = value;

        // An overlay MUST have a start option. Otherwise, it's pointless.
      } else if (key === 'start') {
        throw new Error('invalid "start" option; expected number or string');
      }
    });

    // video.js does not like components with multiple instances binding
    // events to the player because it tracks them at the player level,
    // not at the level of the object doing the binding. This could also be
    // solved with Function.prototype.bind (but not videojs.bind because of
    // its GUID magic), but the anonymous function approach avoids any issues
    // caused by crappy libraries clobbering Function.prototype.bind.
    // - https://github.com/videojs/video.js/issues/3097
    ['endListener_', 'rewindListener_', 'startListener_'].forEach(function (name) {
      _this[name] = function (e) {return Overlay.prototype[name].call((0,assertThisInitialized/* default */.Z)(_this), e);};
    });

    // If the start event is a timeupdate, we need to watch for rewinds (i.e.,
    // when the user seeks backward).
    if (_this.startEvent_ === 'timeupdate') {
      _this.on(player, 'timeupdate', _this.rewindListener_);
    }

    _this.debug("created, listening to \"".concat(
    _this.startEvent_, "\" for \"start\" and \"").concat(_this.
    endEvent_ || 'nothing', "\" for \"end\""));


    _this.hide();return _this;
  }(0,createClass/* default */.Z)(Overlay, [{ key: "createEl", value:

    function createEl() {
      var options = this.options_;
      var content = options.content;

      var background = options.showBackground ?
      'vjs-overlay-background' :
      'vjs-overlay-no-background';
      var el = dom.createEl('div', {
        className: "\n        vjs-overlay\n        vjs-overlay-".concat(

        options.align, "\n        ").concat(
        options["class"], "\n        ").concat(
        background, "\n        vjs-hidden\n      ") });




      if (typeof content === 'string') {
        el.innerHTML = content;
      } else if (content instanceof (window_default()).DocumentFragment) {
        el.appendChild(content);
      } else {
        dom.appendContent(el, content);
      }

      return el;
    }

    /**
     * Logs debug errors
     * @param  {...[type]} args [description]
     * @return {[type]}         [description]
     */ }, { key: "debug", value:
    function debug() {
      if (!this.options_.debug) {
        return;
      }

      var log = video_es["default"].log;
      var fn = log;

      // Support `videojs.log.foo` calls.
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}if (log.hasOwnProperty(args[0]) && typeof log[args[0]] === 'function') {
        fn = log[args.shift()];
      }

      fn.apply(void 0, ["overlay#".concat(this.id(), ": ")].concat(args));
    }

    /**
     * Overrides the inherited method to perform some event binding
     *
     * @return {Overlay}
     */ }, { key: "hide", value:
    function hide() {
      (0,get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Overlay.prototype), "hide", this).call(this);

      this.debug('hidden');
      this.debug("bound `startListener_` to \"".concat(this.startEvent_, "\""));

      // Overlays without an "end" are valid.
      if (this.endEvent_) {
        this.debug("unbound `endListener_` from \"".concat(this.endEvent_, "\""));
        this.off(this.player(), this.endEvent_, this.endListener_);
      }

      this.on(this.player(), this.startEvent_, this.startListener_);

      return this;
    }

    /**
     * Determine whether or not the overlay should hide.
     *
     * @param  {Number} time
     *         The current time reported by the player.
     * @param  {String} type
     *         An event type.
     * @return {Boolean}
     */ }, { key: "shouldHide_", value:
    function shouldHide_(time, type) {
      var end = this.options_.end;

      return isNumber(end) ? time >= end : end === type;
    }

    /**
     * Overrides the inherited method to perform some event binding
     *
     * @return {Overlay}
     */ }, { key: "show", value:
    function show() {
      (0,get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Overlay.prototype), "show", this).call(this);
      this.off(this.player(), this.startEvent_, this.startListener_);
      this.debug('shown');
      this.debug("unbound `startListener_` from \"".concat(this.startEvent_, "\""));

      // Overlays without an "end" are valid.
      if (this.endEvent_) {
        this.debug("bound `endListener_` to \"".concat(this.endEvent_, "\""));
        this.on(this.player(), this.endEvent_, this.endListener_);
      }

      return this;
    }

    /**
     * Determine whether or not the overlay should show.
     *
     * @param  {Number} time
     *         The current time reported by the player.
     * @param  {String} type
     *         An event type.
     * @return {Boolean}
     */ }, { key: "shouldShow_", value:
    function shouldShow_(time, type) {
      var start = this.options_.start;
      var end = this.options_.end;

      if (isNumber(start)) {
        if (isNumber(end)) {
          return time >= start && time < end;

          // In this case, the start is a number and the end is a string. We need
          // to check whether or not the overlay has shown since the last seek.
        } else if (!this.hasShownSinceSeek_) {
          this.hasShownSinceSeek_ = true;
          return time >= start;
        }

        // In this case, the start is a number and the end is a string, but
        // the overlay has shown since the last seek. This means that we need
        // to be sure we aren't re-showing it at a later time than it is
        // scheduled to appear.
        return Math.floor(time) === start;
      }

      return start === type;
    }

    /**
     * Event listener that can trigger the overlay to show.
     *
     * @param  {Event} e
     */ }, { key: "startListener_", value:
    function startListener_(e) {
      var time = this.player().currentTime();

      if (this.shouldShow_(time, e.type)) {
        this.show();
      }
    }

    /**
     * Event listener that can trigger the overlay to show.
     *
     * @param  {Event} e
     */ }, { key: "endListener_", value:
    function endListener_(e) {
      var time = this.player().currentTime();

      if (this.shouldHide_(time, e.type)) {
        this.hide();
      }
    }

    /**
     * Event listener that can looks for rewinds - that is, backward seeks
     * and may hide the overlay as needed.
     *
     * @param  {Event} e
     */ }, { key: "rewindListener_", value:
    function rewindListener_(e) {
      var time = this.player().currentTime();
      var previous = this.previousTime_;
      var start = this.options_.start;
      var end = this.options_.end;

      // Did we seek backward?
      if (time < previous) {
        this.debug('rewind detected');

        // The overlay remains visible if two conditions are met: the end value
        // MUST be an integer and the the current time indicates that the
        // overlay should NOT be visible.
        if (isNumber(end) && !this.shouldShow_(time)) {
          this.debug("hiding; ".concat(
          end, " is an integer and overlay should not show at this time"));

          this.hasShownSinceSeek_ = false;
          this.hide();

          // If the end value is an event name, we cannot reliably decide if the
          // overlay should still be displayed based solely on time; so, we can
          // only queue it up for showing if the seek took us to a point before
          // the start time.
        } else if (hasNoWhitespace(end) && time < start) {
          this.debug("hiding; show point (".concat(
          start, ") is before now (").concat(time, ") and end point (").concat(end, ") is an event"));

          this.hasShownSinceSeek_ = false;
          this.hide();
        }
      }

      this.previousTime_ = time;
    } }]);return Overlay;}(Component);


video_es["default"].registerComponent('Overlay', Overlay);

/**
 * Initialize the plugin.
 *
 * @function plugin
 * @param    {Object} [options={}]
 */
var overlay_plugin_plugin = function plugin(options) {var _this2 = this;
  var settings = video_es["default"].mergeOptions(defaults, options);

  // De-initialize the plugin if it already has an array of overlays.
  if (Array.isArray(this.overlays_)) {
    this.overlays_.forEach(function (overlay) {
      _this2.removeChild(overlay);
      if (_this2.controlBar) {
        _this2.controlBar.removeChild(overlay);
      }
      overlay.dispose();
    });
  }

  var overlays = settings.overlays;

  // We don't want to keep the original array of overlay options around
  // because it doesn't make sense to pass it to each Overlay component.
  delete settings.overlays;

  this.overlays_ = overlays.map(function (o) {
    var mergeOptions = video_es["default"].mergeOptions(settings, o);
    var attachToControlBar =
    typeof mergeOptions.attachToControlBar === 'string' ||
    mergeOptions.attachToControlBar === true;

    if (!_this2.controls() || !_this2.controlBar) {
      return _this2.addChild('overlay', mergeOptions);
    }

    if (attachToControlBar && mergeOptions.align.indexOf('bottom') !== -1) {
      var referenceChild = _this2.controlBar.children()[0];

      if (
      _this2.controlBar.getChild(mergeOptions.attachToControlBar) !== undefined)
      {
        referenceChild = _this2.controlBar.getChild(
        mergeOptions.attachToControlBar);

      }

      if (referenceChild) {
        var controlBarChild = _this2.controlBar.addChild(
        'overlay',
        mergeOptions);


        _this2.controlBar.
        el().
        insertBefore(controlBarChild.el(), referenceChild.el());
        return controlBarChild;
      }
    }

    var playerChild = _this2.addChild('overlay', mergeOptions);

    _this2.el().insertBefore(playerChild.el(), _this2.controlBar.el());
    return playerChild;
  });
};

registerPlugin('overlay', overlay_plugin_plugin);

/* harmony default export */ var overlay_plugin = ((/* unused pure expression or super */ null && (overlay_plugin_plugin)));
// EXTERNAL MODULE: ./node_modules/videojs-mux/dist/videojs-mux.js
var videojs_mux = __webpack_require__(79689);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
;// CONCATENATED MODULE: ./lib/hooks/useVideoStats.tsx










var VIDEO_FRAGMENTS = 5;
var useVideoStats = function useVideoStats(_ref)



{var videoId = _ref.videoId,duration = _ref.duration;
  var currentTimeRef = (0,react.useRef)(null);
  // in seconds
  var SEGMENT_DURATION = duration * 60 / VIDEO_FRAGMENTS;
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var _log = (0,react.useRef)([]);
  var _useVideoWatchMutatio = (0,generated/* useVideoWatchMutation */.CKW)(),_useVideoWatchMutatio2 = (0,slicedToArray/* default */.Z)(_useVideoWatchMutatio, 1),sendVideoWatch = _useVideoWatchMutatio2[0];
  var _useVideoWatchComplet = (0,generated/* useVideoWatchCompletedMutation */.zpD)(),_useVideoWatchComplet2 = (0,slicedToArray/* default */.Z)(_useVideoWatchComplet, 1),sendVideoCompleted = _useVideoWatchComplet2[0];

  (0,react.useEffect)(function () {
    return function () {
      var time = currentTimeRef.current;
      if (time > 0) {
        sendVideoWatch({
          variables: {
            videoId: videoId,
            seconds: Math.floor(time % VIDEO_FRAGMENTS),
            cursorAt: Math.floor(time) },

          update: function update(cache) {
            cache.modify({
              id: "Video:".concat(videoId),
              broadcast: true,
              fields: {
                cursorAt: function cursorAt() {
                  return Math.floor(time);
                } } });


          } });

        _log.current = [];
        currentTimeRef.current = null;
      }
    };
  }, []);

  var videoProgress = (0,react.useCallback)(
  function (currentTime) {
    if (!flags.video_stats) {
      return null;
    }
    // start at 1
    var segmentIndex = Math.floor(currentTime / SEGMENT_DURATION) + 1;

    // if user resets cursor we re-send event, so we clean up
    _log.current = _log.current.filter(function (item) {
      // user probably reset player
      if (item.timestamp > currentTime) {
        return false;
      }
      return true;
    });

    var segmentEventSent = _log.current.some(function (el) {
      if (el.segmentIndex === segmentIndex) {
        return true;
      }
      return false;
    });

    if (
    // didn't send an event already
    !segmentEventSent &&
    // must have completed at least 90% of the current
    currentTime % SEGMENT_DURATION > SEGMENT_DURATION * 0.9)
    {
      _log.current.push({
        videoId: videoId,
        segmentIndex: segmentIndex,
        timestamp: currentTime });

      if (segmentIndex === 4) {
        sendVideoCompleted({
          variables: {
            videoId: videoId,
            cursorAt: Math.floor(currentTime),
            seconds: Math.floor(SEGMENT_DURATION) } });


      } else {
        sendVideoWatch({
          variables: {
            videoId: videoId,
            seconds: Math.floor(SEGMENT_DURATION),
            cursorAt: Math.floor(currentTime) } });


      }
    }
  },
  [flags]);


  var trackVideo = function trackVideo(videoEl) {
    videoEl.addEventListener('timeupdate', function () {
      currentTimeRef.current = videoEl.currentTime;
      videoProgress(videoEl.currentTime);
    });
  };

  //
  return trackVideo;
};
;// CONCATENATED MODULE: ./organisms/video-player/index.tsx
var _excluded = ["video"],_excluded2 = ["thumbnailImage", "isLimited", "tags"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






















var VideoWrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "video-player__VideoWrapper", componentId: "sc-16ykqt0-0" })(["position:relative;display:flex;flex-direction:column-reverse;.video-js.vjs-has-started + .limitedAccessMsg{display:block;}.limitedAccessMsg{display:none;width:100%;.vjs-overlay-preview{display:block;width:100%;color:#fff;font-size:14px;font-weight:600;text-align:left;padding:10px;white-space:nowrap;background-color:#667c91;}}"]);


























var Tags = styled_components_browser_esm["default"].div.withConfig({ displayName: "video-player__Tags", componentId: "sc-16ykqt0-1" })([".vjs-has-started &{display:none;}position:absolute;top:10px;left:10px;z-index:1;"]);










var Tag = styled_components_browser_esm["default"].span.withConfig({ displayName: "video-player__Tag", componentId: "sc-16ykqt0-2" })(["color:white;font-size:11px;text-transform:uppercase;border-radius:3px;padding:3px 5px;background-color:#88bfbd;"]);








video_es["default"].registerComponent('VjsCustomButton', vjsCustomButton);
video_es["default"].registerComponent('VjsAirplayButton', vjsAirplayButton);

if (true) {
  // eslint-disable-next-line
  __webpack_require__(74572)(video_es["default"], {});
  video_es["default"].registerPlugin('hlsQualitySelector', (videojs_hls_quality_selector_cjs_default()));
}

// const TRIAL_DURATION = 60.010667;

function getVideoSource(hlsDisabled, video) {
  if (hlsDisabled) {
    return (0,toConsumableArray/* default */.Z)(video.player.current.assets).
    sort(function (a, b) {return b.resolution - a.resolution;}).
    map(function (source) {
      if (!source.src) {
        return null;
      }
      return {
        src: source.src,
        type: 'video/mp4',
        label: "".concat(source.resolution, "p"),
        res: source.resolution };

    });
  } else {
    return [{ src: video.hls, type: 'application/x-mpegURL' }];
  }
}

function getVideoConfig(_ref) {var hlsDisabled = _ref.hlsDisabled,video = _ref.video,currentUser = _ref.currentUser;
  var mux = null;
  if (currentUser !== null && currentUser !== void 0 && currentUser.isNoneTrialPremium) {var _video$content;
    mux = {
      debug: false,
      data: {
        env_key: "j99fao95258fuq91trefqtn1n",
        // Player Metadata
        player_name: 'video.js',
        player_version: package_namespaceObject.HO.rA,
        player_init_time: Date.now(),
        // Video Metadata
        video_id: video.identifier,
        video_title: video === null || video === void 0 ? void 0 : (_video$content = video.content) === null || _video$content === void 0 ? void 0 : _video$content.title,
        video_series: '',
        video_duration: (video === null || video === void 0 ? void 0 : video.minutes) * 60 * 1000, // in milliseconds, ex: 120000
        // user
        user_id: currentUser.id } };


  }
  if (hlsDisabled) {
    return {
      plugins: {
        mux: mux,
        videoJsResolutionSwitcher: {
          "default": video.kind === 'audio' ? 360 : 720,
          dynamicLabel: false } } };



  } else {
    var overrideNative = true;
    return {
      plugins: {
        mux: mux },

      html5: {
        hls: {
          overrideNative: overrideNative },

        vhs: {
          overrideNative: overrideNative },

        nativeVideoTracks: overrideNative,
        nativeAudioTracks: overrideNative,
        nativeTextTracks: overrideNative } };


  }
}





var createVideoElement = function createVideoElement(
container,
config)
{
  var video = config.video,isAirPlayDevice = config.isAirPlayDevice;
  var videoEl = document.createElement('video');
  videoEl.src = isAirPlayDevice ? video.hls : '';
  videoEl.muted = false;
  //
  videoEl.classList.add('video-js', 'vjs-default-skin', 'vjs-16-9');
  if (video.kind === 'audio') {
    videoEl.classList.add('vjs-audio');
  }
  //
  container.appendChild(videoEl);
  return videoEl;
};

// const applicationId = '3552EF75'; // monssef@yogobe.com
var applicationId = '87B0FFF1'; // new app id
var _castLoaded = false;
var VideoPlayer = function VideoPlayer(props) {var _props$video, _props$video$meta;
  var player = (0,react.useRef)(null);
  var videoContainerRef = (0,react.useRef)(null);
  var videoElementID = props.elementID || 'video_element';
  if (props !== null && props !== void 0 && props.video.identifier) {
    videoElementID = "_".concat(props === null || props === void 0 ? void 0 : props.video.identifier);
  }
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var userRef = (0,react.useRef)(null);
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];
  var _useState = (0,react.useState)(false),showLimitBanner = _useState[0],setShowLimitBanner = _useState[1];
  var _useState2 = (0,react.useState)({}),errored = _useState2[0],setErrored = _useState2[1];
  var trackVideo = useVideoStats({
    videoId: props === null || props === void 0 ? void 0 : props.video.id,
    duration: props === null || props === void 0 ? void 0 : (_props$video = props.video) === null || _props$video === void 0 ? void 0 : (_props$video$meta = _props$video.meta) === null || _props$video$meta === void 0 ? void 0 : _props$video$meta.minutes });


  var _useCastModal = useCastModal({
    open: false }),_useCastModal2 = (0,slicedToArray/* default */.Z)(_useCastModal, 2),castModal = _useCastModal2[0],openCastModal = _useCastModal2[1].openModal;

  var _useLoginModal = (0,useLoginModal/* default */.Z)({
    open: false }),_useLoginModal2 = (0,slicedToArray/* default */.Z)(_useLoginModal, 2),loginModal = _useLoginModal2[0],openLoginModal = _useLoginModal2[1].openModal;


  var onPlay = function onPlay(video) {var _video$currentTime;
    props.onPlay ? props.onPlay(video) : null;

    if ((video === null || video === void 0 ? void 0 : (_video$currentTime = video.currentTime) === null || _video$currentTime === void 0 ? void 0 : _video$currentTime.call(video)) === 0) {var _props$onPlayStart;
      (_props$onPlayStart = props.onPlayStart) === null || _props$onPlayStart === void 0 ? void 0 : _props$onPlayStart.call(props, video);
    }
  };

  var onPause = function onPause(video) {
    props.onPause ? props.onPause(video) : null;
  };

  var addClassToControlBar = function addClassToControlBar(classname) {
    var controlBar = document.querySelector('.vjs-control-bar');
    if (controlBar) {
      controlBar.classList.add(classname);
    }
  };

  var getCastMediaParams = function getCastMediaParams() {
    var assets = (0,toConsumableArray/* default */.Z)(props.video.player.assets).reduce(function (acc, asset) {
      acc[asset.resolution] = asset;
      return acc;
    }, {});

    // let mediaSrc, mediaType;
    // we set mp4 playlist as default
    var mediaSrc = assets['720'].src || assets['1080'].src;
    var mediaType = 'video/mp4';

    return { id: mediaSrc, src: mediaSrc, type: mediaType };
  };

  (0,react.useEffect)(function () {
    // used ref for canCast, because closure of canCast keeps old value in currentUser
    userRef.current = currentUser;
  }, [currentUser]);

  function canCast() {var _userRef$current, _userRef$current2;
    if (props.video.hasAccess || (_userRef$current = userRef.current) !== null && _userRef$current !== void 0 && _userRef$current.isPremium) {
      return true;
    } else if (((_userRef$current2 = userRef.current) === null || _userRef$current2 === void 0 ? void 0 : _userRef$current2.isPremium) === false) {
      openCastModal();
    } else {
      openLoginModal();
    }

    return false;
  }

  var isAirPlayDevice = (0,react.useMemo)(function () {var _window;
    return  true ?
    !!((_window = window) !== null && _window !== void 0 && _window.WebKitPlaybackTargetAvailabilityEvent) :
    0;
  }, []);

  var setupVideoPlayer = function setupVideoPlayer() {
    var video = props.video,otherProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);
    if (videoContainerRef.current) {
      var videoElement = createVideoElement(videoContainerRef.current, {
        video: video,
        isAirPlayDevice: isAirPlayDevice });

      //
      player.current = (0,video_es["default"])(
      videoElement, _objectSpread(_objectSpread(_objectSpread({},

      otherProps), {}, {
        sources: getVideoSource(flags === null || flags === void 0 ? void 0 : flags.disable_hls, video),
        poster: thumbnailImage,
        aspectRatio: '16:9',
        controls: false,
        controlBar: {
          playToggle: true,
          volumePanel: {
            // inline: false,
            // vertical: true,
            mouseVolumeLevelDisplay: true,
            horizontal: true },

          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true,
          subtitlesButton: false,
          pictureInPictureToggle: false },

        // playbackRates: [0.5, 1, 1.5, 2],
        defaultPlaybackRate: 1 },
      getVideoConfig({
        hlsDisabled: flags === null || flags === void 0 ? void 0 : flags.disable_hls,
        video: video,
        currentUser: currentUser })), {}, {

        techOrder: ['chromecast', 'html5'], // Required
        // Configuration for the Chromecast Tech
        chromecast: {
          source: getCastMediaParams(),
          requestTitleFn: function requestTitleFn() {
            return video.content.title;
          },
          requestSubtitleFn: function requestSubtitleFn() {
            var deviceName = player.current['chromecastSessionManager'].
            getCastContext().
            getCurrentSession().
            getCastDevice().friendlyName;
            return "Casting to ".concat(deviceName);
          },
          requestCastSubtitleFn: function requestCastSubtitleFn() {
            return ' ';
          },
          requestCastTitleFn: function requestCastTitleFn() {
            return video.content.title;
          } } }),


      function onPlayerReady() {var _player$current2,_player$current3,_player$current3$cont,_player$current3$cont2,_this = this;
        player.current.src(getVideoSource(flags === null || flags === void 0 ? void 0 : flags.disable_hls, video));
        // if ((video?.meta?.minutes * 60) / video.cursorAt > 0.95) {
        //   player.current.currentTime(video.cursorAt);
        // }
        player.current.controlBar.
        addChild('spacer').
        addClass('vjs-mobile-center-spacer');
        //
        if (!(flags !== null && flags !== void 0 && flags.disable_hls)) {var _player$current, _player$current$hlsQu;
          // @ts-ignore
          (_player$current = player.current) === null || _player$current === void 0 ? void 0 : (_player$current$hlsQu = _player$current.hlsQualitySelector) === null || _player$current$hlsQu === void 0 ? void 0 : _player$current$hlsQu.call(_player$current);
        }
        //
        // @ts-ignore
        (_player$current2 = player.current) === null || _player$current2 === void 0 ? void 0 : _player$current2.chromecast({
          receiverAppID: applicationId,
          addButtonToControlBar: true, // Defaults to true
          canCast: canCast });

        // for some reason `subtitlesButton` in config is not working
        // @ts-ignore
        (_player$current3 = player.current) === null || _player$current3 === void 0 ? void 0 : (_player$current3$cont = _player$current3.controlBar.subsCapsButton) === null || _player$current3$cont === void 0 ? void 0 : (_player$current3$cont2 = _player$current3$cont.disable) === null || _player$current3$cont2 === void 0 ? void 0 : _player$current3$cont2.call(_player$current3$cont);
        //
        var limitedAccessMsg = document.querySelector(".".concat(
        videoElementID, "--limitedAccessMsg"));

        this.on('play', function () {
          onPlay(_this);
        });

        this.on('pause', function () {
          onPause(_this);
        });

        this.on('click', function (e) {
          var isMobile = window.matchMedia("(max-width: ".concat(
          theme.viewports.tablet, "px)")).
          matches;

          if (
          // mobile view
          isMobile && e.target.matches('.vjs-control-bar') ||
          // desktop view
          !isMobile && e.target.matches('video') && _this.hasStarted())
          {
            try {
              if (_this.paused()) {
                _this.play();
              } else {
                _this.pause();
              }
            } catch (ex) {
              //
            }
          }
        });

        this.on('loadedmetadata', function () {
          var duration = this.duration();
          var overlays = [];
          if (props.isLimited) {
            addClassToControlBar('vjs-overlayed');
            limitedAccessMsg.innerHTML = "<div class=\"vjs-overlay-preview\"><i class=\"ygb-icon-infob\"></i> ".concat( /*i18n*/esm/* i18n._ */.ag._("video.preview_msg"), "</div>");
            overlays.push({
              content: "<i class=\"ygb-icon-infob\"></i> ".concat( /*i18n*/esm/* i18n._ */.ag._("video.preview_msg")),
              start: 'play',
              end: Math.floor(duration - 6),
              "class": 'vjs-overlay-preview' });

          }

          this.overlay({
            content: 'overlay content',
            debug: false,
            overlays: overlays });

        });

        if (!props.isPlayList) {
          this.on('timeupdate', function () {
            if (typeof props.onTimeUpdate === 'function') {var _this$currentTime;
              props.onTimeUpdate(_this.duration(), (_this$currentTime = _this.currentTime) === null || _this$currentTime === void 0 ? void 0 : _this$currentTime.call(_this));
            }
          });
        }

        this.on('error', function (error) {var _props$video2, _props$video3;
          esm_exports/* captureException */.Tb(error, {
            contexts: {
              video: {
                id: props === null || props === void 0 ? void 0 : (_props$video2 = props.video) === null || _props$video2 === void 0 ? void 0 : _props$video2.id,
                hsl: props === null || props === void 0 ? void 0 : (_props$video3 = props.video) === null || _props$video3 === void 0 ? void 0 : _props$video3.hls } } });



          var newErrored = errored;
          var resolution;
          if (flags !== null && flags !== void 0 && flags.disable_hls) {
            resolution = this.currentResolutionState.label;
          } else {var _player$current$quali;
            // @ts-ignore
            var index = player.current.qualityLevels().selectedIndex;
            // @ts-ignore
            resolution = (_player$current$quali = player.current.qualityLevels(index)) === null || _player$current$quali === void 0 ? void 0 : _player$current$quali.height;
          }
          if (newErrored[resolution]) {
            newErrored[resolution] = 1;
          } else {
            newErrored[resolution]++;
          }
          setErrored(newErrored);
          if (newErrored[resolution] <= 2) {
            videoElement.load();
          }
        });

        this.on('ended', function () {
          setShowLimitBanner(true);
          (0,manager/* default */.Z)()._PIXEL_TRACK('Video Completion', true);
          if (props.onEnd) {
            props.onEnd();
          }
          if (window.fullScreen) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            }
          }
        });
        this.on('dblclick', function () {
          if (
          document.fullscreenElement /* Standard syntax */ ||
          document.webkitFullscreenElement /* Chrome, Safari and Opera syntax */ ||
          document.mozFullScreenElement /* Firefox syntax */ ||
          document.msFullscreenElement /* IE/Edge syntax */)
          {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              /* Firefox */
              document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
              /* Chrome, Safari and Opera */
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
              /* IE/Edge */
              document.msExitFullscreen();
            }
          } else {
            this.requestFullscreen();
          }
        });
      });

      trackVideo(videoElement);
      if (window.WebKitPlaybackTargetAvailabilityEvent) {
        videoElement.addEventListener(
        'webkitplaybacktargetavailabilitychanged',
        function (event) {var _player$current6, _player$current6$getC;
          // @ts-ignore
          switch (event.availability) {
            case 'available':
              try {var _player$current4, _player$current4$getC;
                var child = (_player$current4 = player.current) === null || _player$current4 === void 0 ? void 0 : (_player$current4$getC = _player$current4.
                getChild('controlBar')) === null || _player$current4$getC === void 0 ? void 0 : _player$current4$getC.
                getChild('VjsAirplayButton');
                if (!child) {var _player$current5, _player$current5$getC;
                  (_player$current5 = player.current) === null || _player$current5 === void 0 ? void 0 : (_player$current5$getC = _player$current5.
                  getChild('controlBar')) === null || _player$current5$getC === void 0 ? void 0 : _player$current5$getC.
                  addChild('VjsAirplayButton');
                }
              } catch (err) {
                console.error(err);
              }
              break;
            case 'not-available':
              (_player$current6 = player.current) === null || _player$current6 === void 0 ? void 0 : (_player$current6$getC = _player$current6.
              getChild('controlBar')
              // @ts-ignore
              ) === null || _player$current6$getC === void 0 ? void 0 : _player$current6$getC.removeChild(vjsAirplayButton);
              break;}

        });

      }
      if (props.isPlayList) {
        player.current.addClass('video-playlist');
        player.current.getChild('controlBar').addChild('VjsCustomButton', {
          type: 'next',
          next: function next() {
            props.playNextVideo();
          } });

        player.current.getChild('controlBar').addChild('VjsCustomButton', {
          type: 'prev',
          prev: function prev() {
            props.playPrevVideo();
          } });

      }

      var togglePlayer = function togglePlayer(e) {
        // if space is clicked
        // we check that event is not triggered on input button and anchor
        // because those should will handle the event instead
        if (
        e.key === ' ' &&
        ![
        'HTMLInputElement',
        'HTMLButtonElement',
        'HTMLAnchorElement',
        'HTMLTextAreaElement'].
        includes(e.target.constructor.name))
        {
          e.preventDefault();
          try {
            if (player.current.paused()) {
              player.current.play();
            } else {
              player.current.pause();
            }
          } catch (ex) {
            //
          }
        }
      };

      window.addEventListener('keydown', togglePlayer);

      return function () {
        window.removeEventListener('keydown', togglePlayer);

        if (player) {
          try {
            player.current.dispose();
            player.current = null;
          } catch (ex) {
            // idk why the above crashes
          }
        }
      };
    }
  };

  (0,react.useEffect)(function () {
    if (flags !== null && flags !== void 0 && flags.disable_hls) {
      videoSourcesSwitcher();
    }

    try {
      if (player.current) {
        player.current.dispose();
        player.current = null;
      }
      setupVideoPlayer();
    } catch (error) {
      esm_exports/* captureException */.Tb(error);
    }
  }, []);

  (0,react.useEffect)(function () {
    if (!_castLoaded) {
      CastLoader.load().
      then(function () {return _castLoaded = true;})["catch"](
      function () {
        //
      });
    }
    // prevent safari from adding controls attribute to video
    var video = document.querySelector('video');
    var observer = null;
    if (video) {
      observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (
          mutation.type == 'attributes' &&
          mutation.attributeName === 'controls')
          {
            video.removeAttribute('controls');
          }
        });
      });

      observer.observe(video, {
        attributes: true });

    }
    //

    return function () {var _observer;
      (_observer = observer) === null || _observer === void 0 ? void 0 : _observer.disconnect();
    };
  }, []);

  var thumbnailImage = props.thumbnailImage,isLimited = props.isLimited,_props$tags = props.tags,tags = _props$tags === void 0 ? [] : _props$tags,rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);

  var LockedOverlay = rest.videoEndOverlay || video_player_VideoCoverLocked;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(errorboundary/* ErrorBoundary */.SV, { onError: console.error, children: [






      showLimitBanner && isLimited ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(LockedOverlay, {}) : /*#__PURE__*/

      (0,jsx_runtime.jsxs)(VideoWrapper, {
        ref: videoContainerRef,
        id: videoElementID,
        className: [rest.className, 'VideoPlayer--Container'].join(' '), children: [


        (tags === null || tags === void 0 ? void 0 : tags.length) > 0 ? /*#__PURE__*/
        (0,jsx_runtime.jsx)(Tags, { children:
          tags.map(function (tag) {return /*#__PURE__*/(
              (0,jsx_runtime.jsx)(Tag, { className: "videoplayer-tag", children:
                tag }, tag));}) }) :



        null, /*#__PURE__*/
        (0,jsx_runtime.jsx)("div", {
          // need to keep this unique for when there's multiple video players on the page
          className: "".concat(videoElementID, "--limitedAccessMsg limitedAccessMsg") })] }),



      castModal,
      loginModal] }));


};

/* harmony default export */ var video_player = (VideoPlayer);

/***/ }),

/***/ 25893:
/***/ (function() {

/* (ignored) */

/***/ })

}]);